// extracted by mini-css-extract-plugin
module.exports = {"price":"dM","currency":"dN","strikethrough":"dO","secondary":"dP"};